function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import RichTextEditor from 'react-rte';
import { posActions } from '../../reducers/pos.reducer';
import PageData from './page/Page.context';
import PageDetails from './page/PageDetails.react';
import PageDelete from './page/PageDelete.react';
import PageArticles from './page/PageArticles.react';
import PageBanner from './page/PageBanner.react';
import PosillicoLandingPage from './react-components/PosillicoLandingPage.react';
import PageSEO from './page/PageSEO.react';

// TODO :: Stop if app / type is not in constants
// TODO :: make call with pageID to get latest article
var PosPage = function PosPage(_ref) {
  var pagesAction = _ref.pagesAction;
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app,
    pageID = _useParams.pageID;
  var pages = useSelector(function (s) {
    return s.pos.pages;
  });
  var _useState = useState({
      pageID: null,
      archived: null,
      app: '',
      title: '',
      internalUrl: '',
      type: '',
      published: {},
      sidebar: {
        isVisible: false,
        title: ''
      },
      calculator: false,
      contactPerson: {
        isVisible: false,
        title: '',
        contactID: null
      },
      topNavBar: true,
      bottomNavBar: {
        isVisible: false,
        position: 'bottom'
      },
      description: '',
      articleType: 'default',
      articles: [],
      banner: {
        paragraph: RichTextEditor.createEmptyValue()
      },
      page: {},
      reactComponent: null,
      posillicoLandingPage: [],
      metadata: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    pagesAction({
      formData: {
        pageID: pageID
      }
    });
  }, [pageID]);
  useEffect(function () {
    var page = Object.values(pages).find(function (x) {
      return x._id === pageID;
    });
    if (page) {
      var _page$banner, _page$banner$paragrap;
      var publishedObj = {};
      page.published.forEach(function (x) {
        if (x.isPublished) publishedObj[x.clientEnv] = true;
      });
      setState({
        page: page,
        pageID: page._id,
        app: page.clientApp,
        title: page.title,
        internalUrl: page.internalUrl,
        type: page.type,
        published: publishedObj,
        sidebar: {
          isVisible: page.sidebar.isVisible,
          title: page.sidebar.title || ''
        },
        calculator: page.calculator,
        contactPerson: {
          isVisible: page.contactPerson.isVisible,
          title: page.contactPerson.title || '',
          contactID: page.contactPerson.contactID || null
        },
        topNavBar: page.topNavBar,
        bottomNavBar: {
          isVisible: page.bottomNavBar.isVisible,
          position: page.bottomNavBar.position || 'bottom'
        },
        description: page.description || '',
        articleType: page.articleType,
        articles: page.articles,
        banner: _objectSpread(_objectSpread({}, page.banner), {}, {
          paragraph: (page === null || page === void 0 ? void 0 : (_page$banner = page.banner) === null || _page$banner === void 0 ? void 0 : (_page$banner$paragrap = _page$banner.paragraph) === null || _page$banner$paragrap === void 0 ? void 0 : _page$banner$paragrap.length) > 0 ? RichTextEditor.createEmptyValue().setContentFromString(page.banner.paragraph, 'html') : RichTextEditor.createEmptyValue()
        }) || {},
        reactComponent: page.reactComponent || null,
        posillicoLandingPage: page.posillicoLandingPage || [],
        metadata: page.metadata || null,
        archived: page.archived
      });
    }
  }, [pageID, pages]);
  var archived = state.archived;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, app && /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--back",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      navigate("/".concat(app, "/pages"));
    }
  }, "back")), /*#__PURE__*/React.createElement(PageDetails, null), /*#__PURE__*/React.createElement(PageBanner, null), /*#__PURE__*/React.createElement(PageSEO, null), /*#__PURE__*/React.createElement(PageArticles, {
    pageID: pageID
  }), !archived && /*#__PURE__*/React.createElement(PageDelete, {
    pageID: pageID
  }), /*#__PURE__*/React.createElement(PosillicoLandingPage, null))));
};
var mdtp = {
  pagesAction: posActions.pages
};
export default connect(null, mdtp)(PosPage);